import "./footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot, faPhone, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

function Footer() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const navItems = [
    { path: "/", title: t("Início") },
    {
      title: t("Empresa"),
      isDropdown: true,
      items: [
        { path: "/AboutUs", title: t("Sobre nós") },
        { path: "/?scroll=meioambiente", title: t("Sustentabilidade e meio ambiente") },
      ],
    },
    { path: "/Capabilities/Production", title: t("Competências") },
    {
      title: t("Contato"),
      isDropdown: true,
      items: [
        { path: "/ContactUs", title: t("Fale Conosco") },
        { path: "/Denuncia", title: t("Canal de denúncias") },
      ],
    },
    { path: "/?scroll=certificados", title: t("Certificados") },
    { path: "/Customers", title: t("Clientes") },
  ];

  const handleNavClick = (path) => {
    navigate(path);
  };

  const renderNavItems = () =>
    navItems.map((item, index) => {
      if (item.isDropdown) {
        const primaryPath = item.items?.[0]?.path || "/";

        return (
          <div key={index} className="footer-dropdown">
            {/* Título (desktop only) */}
            <span className="d-none d-md-block">{item.title}</span>

            {/* Link simplificado (mobile only) - leva para a primeira rota do dropdown */}
            <Link
              to={primaryPath}
              className="footer-link d-block d-md-none"
              onClick={() => handleNavClick(primaryPath)}
            >
              {item.title}
            </Link>

            {/* Dropdown (desktop only) */}
            <ul className="footer-dropdown-list d-none d-md-block">
              {item.items.map((subItem, subIndex) =>
                subItem.divider ? (
                  <hr key={subIndex} />
                ) : (
                  <li key={subIndex}>
                    <Link
                      to={subItem.path}
                      className="footer-link"
                      onClick={() => handleNavClick(subItem.path)}
                    >
                      {subItem.title}
                    </Link>
                  </li>
                )
              )}
            </ul>
          </div>
        );
      }

      return (
        <div key={index} className="footer-link-item">
          <Link
            to={item.path}
            className="footer-link"
            onClick={() => handleNavClick(item.path)}
          >
            {item.title}
          </Link>
        </div>
      );
    });

  return (
    <div className="container-fluid p-0">
      <footer className="footer" id="footer">
        <div className="row m-0 p-4 p-md-5 text-white align-items-start" style={{ backgroundColor: "#d62027" }}>

          {/* COLUNA 1: SOBRE / LOGO */}
          <div className="col-lg-4 col-md-12 mb-4 text-center text-md-start">
            <h4 className="fw-bold mb-3">{t("footer.companyName")}</h4>
            <p className="mb-4">{t("footer.description")}</p>

            <Link
              to="/ContactUs"
              className="btn btn-footer fw-bold px-4 py-2 d-inline-block text-center"
            >
              {t("footer.contactButton")}
            </Link>
          </div>

          {/* COLUNA 2: MENU */}
          <div className="col-lg-2 col-md-6 mb-4 text-center text-md-start">
            <h5 className="fw-bold  ">{t("footer.menuTitle")}</h5>
            <div className="footer-nav ">{renderNavItems()}</div>
          </div>

          {/* COLUNA 3: CONTATO */}
          <div className="col-lg-3 col-md-6 mb-4 text-center text-md-start">
            <h5 className="fw-bold">{t("footer.contactTitle")}</h5>
            <p className="m-0">
              <FontAwesomeIcon icon={faLocationDot} className="me-2" />
              {t("footer.contact.address")}
            </p>
            <p className="m-0 mt-2">
              <FontAwesomeIcon icon={faEnvelope} className="me-2" />
              {t("footer.contact.email")}
            </p>
            <p className="m-0 mt-2">
              <FontAwesomeIcon icon={faPhone} className="me-2" />
              {t("footer.contact.phone")}
            </p>
          </div>

          {/* COLUNA 4: MAPA */}
          <div className="col-lg-3 col-md-12 mb-4">
            <div className="mt-0">
              <iframe
                title="localizacao"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14768.85513136809!2d-46.375587005272884!3d-22.269890256221565!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94c97750f2fd4ef7%3A0x6d5f8505a9504627!2sMG%20SUL%20Sistemas%20Automotivos!5e0!3m2!1spt-BR!2sbr!4v1760552373499!5m2!1spt-BR!2sbr"
                width="100%"
                height="200"
                style={{ border: 0, borderRadius: "8px" }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>

        {/* RODAPÉ INFERIOR */}
        <div className="text-center pt-2 text-white footer-bottom" style={{ backgroundColor: "#b21922" }}>
          <p className="m-0">
            © {new Date().getFullYear()} MGSUL - Sistemas Automotivos <br />
            {t("footer.rights")}
          </p>
        </div>
      </footer>
    </div>
  );
}

export default Footer;
